var secret = "38384040373937396665"; // konami
//var secret = "6665"; // konami
var input = "";
var timer;
var mode = false;
var esc = "27";

$(document).keyup(function(e) { 
    input += e.which;   
    clearTimeout(timer);
    timer = setTimeout(function() { input = ""; }, 750);
   
    check_input();
});

function check_input() {
    if(input == secret) {
        // the secret code
        $('body').append('<div class="boat-wrapper"><div class="boat"></div></div>')
    }

    if(input == esc) {
        $('.boat-wrapper').remove();
    }
}